import { Component, OnInit } from '@angular/core';
import { Tutor } from '../../models/tutor.model';
import { TutorService } from '../../services/tutor.service';

@Component({
    selector: 'app-tutor-edition',
    templateUrl: './tutor-edition.component.html',
    styleUrls: ['./tutor-edition.component.scss']
})
export class TutorEditionComponent implements OnInit {

    public headerTitle     : string = 'Mi perfil';
    public headerButtonText: string = 'Volver';
    public headerButtonIcon: string = 'arrow-left';
    public headerButtonUrl : string = '/tutor';

    public tutor: Tutor;
    public isLoadingData: boolean = true;

    constructor(private tutorService: TutorService) { }

    ngOnInit(): void {

        this.tutorService.get().subscribe({
            next: (data: Tutor) => {
                this.tutor = data;
            }
        }).add(() => {
            this.isLoadingData = false;
        });

    }

}
